// Reads the user id out of the stored JWT without a network round-trip.
//
// The token is NOT trusted for anything here — it is only ever used to key client-side
// storage and to identify the user to RevenueCat. Every actual authorization decision is
// the server's, which verifies the signature. A tampered token yields a wrong id and
// nothing more than a wrong cache bucket.
//
// Centralised because two call sites now need it (insights cache keying and RevenueCat
// identification) and they must agree on the claim name — `userId` is what
// server/routes/auth.js signs, `sub` is the JOSE-standard fallback.
export function userIdFromToken(token = localStorage.getItem('token')) {
  if (!token || typeof token !== 'string') return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.userId || payload.sub || null;
  } catch {
    return null;
  }
}
